import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { ErrorPage } from 'cpfr-common';
import { fetchNotFoundErrorPage } from './NotFoundErrorPageSlice';
import { NotFoundErrorPageContentSelector } from './NotFoundErrorPageContentSelector';

export function useNotFoundErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchNotFoundErrorPage, NotFoundErrorPageContentSelector);
}
